import React from "react";
import { addDelegates, pushToSNS } from "../api/DelegateAPI";
import Slider from './Slider';
import StatePicker from "./StatePicker";
import { refreshAccessToken } from "../api/oauthAPI";
import { retrieveByEid } from "../api/mdmAPI"
import { retrieveFirmContactData, retrieveFirmContactDataByTaxId } from "../api/DelegateAPI"
import '../css/Formatting.css';

export default function FCAdd(props) {

  function addPhoneFormat(){
    let el=document.getElementById("phoneADD").value
    el = el.split('(').join('');
    el = el.split(')').join('');
    el = el.split('-').join('');
    if(el.length > 6) {
      let newVal = "(" + el.substring(0,3) + ")" + el.substring(3,6) + "-"+ el.substring(6);
      document.getElementById("phoneADD").value = newVal
    } else if (el.length > 3) {
      let newVal = "(" + el.substring(0,3) + ")" + el.substring(3,6);
      document.getElementById("phoneADD").value = newVal
    }
  }
  function addZipFormat(){
    let el=document.getElementById("zipADD").value
    el = el.split('-').join('');
    if(el.length > 5) {
      let newVal = el.substring(0,5) + "-" + el.substring(5);
      document.getElementById("zipADD").value = newVal
    } 
  }
  function isNumber(num) {
    return !isNaN(parseFloat(num)) && isFinite(num);
  }
  let buttonName = 'Request New Firm Contact'
  if (props.CSR) {
    buttonName = 'Build Firm Contact'
  }

  let identifier = props.searchValue;
  if (isNumber(identifier)) {
    identifier = identifier + ' - (' + props.fcResponse[0].eid + ')'
  }
  let compensationStatements, commissions, managementCompensation, variableManagementComp, currentAccess, demographicData

  const firmEid = props.fcResponse[0].eid
  const singleFirmEid = firmEid.substring(0, 9)
  let firmName = 'unknown'
  if (props.fcResponse[0].name) {
    firmName = props.fcResponse[0].name.lastName
  }
  let add1 = ''
  let add2 = ''
  let city = ''
  let state = ' '
  let zip = ''
  if (props.address && props.address.line1) {
    add1 = props.address.line1
    city = props.address.city
    state = props.address.stateCode
    zip = props.address.postalCode
    if (props.address.line2){
      add2 = props.address.line2
    }
    if (props.address.postalExtension) {
      zip = zip + "-" + props.address.postalExtension
    }
  }

  currentAccess = true
  demographicData = true
  compensationStatements = false
  commissions = false
  managementCompensation = false
  variableManagementComp = false

  function returnToFcList() {
    props.setFcEditMode(false)
    props.setFcAddMode(false)
    props.setIsDemographicAdd(true)
    props.setGlobalAlert(
      {
        hidden: true,
      }
    )
    document.getElementById("demographicDataAdd").checked = true
  }

  function convertBooleanToYesNo(input) {
    if (input) {
      return "Yes";
    } else {
      return "No";
    }
  }
  function convertBooleanToAccessCode(input) {
    if (input) {
      return "1";
    } else {
      return "2";
    }
  }
  function validEntry() {
    let error = false;
    if (document.getElementById("firstNameADD").value.length < 2) {
      document.getElementById("firstNameADD").focus()
      error = true
    }
    if (!error && document.getElementById("lastNameADD").value.length < 2) {
      document.getElementById("lastNameADD").focus()
      error = true
    }

    if (!error && document.getElementById("emailADD").value.length < 2) {
      document.getElementById("emailADD").focus()
      error = true
    }

    if (!error && document.getElementById("phoneADD").value.length !== 13) {
      document.getElementById("phoneADD").focus()
      error = true
    }

    if (!error && document.getElementById("address1ADD").value.length < 2) {
      document.getElementById("address1ADD").focus()
      error = true
    }

    if (!error && document.getElementById("cityADD").value.length < 2) {
      document.getElementById("cityADD").focus()
      error = true
    }

    if (!error && document.getElementById("stateADD").value.length < 2) {
      document.getElementById("stateADD").focus()
      error = true
    }

    if (!error && document.getElementById("zipADD").value.length < 5) {
      document.getElementById("zipADD").focus()
      error = true
    }
    
    if (error) {
      props.setGlobalAlert(
        {
          id: "required-field-alert",
          type: "error",
          message:
            "Please enter all required fields. ",
          hidden: false,
        }
      )
      return false;
    } else {
      props.setGlobalAlert(
        {
          hidden: true,
        }
      )
      return true;
    }
  }

  async function switchAddMode() {
    const isDemographicAdd = document.getElementById("demographicDataAdd").checked

    if (isDemographicAdd) {
      props.setIsDemographicAdd(true)
    } else {
      props.setIsDemographicAdd(false)
    }
  }
  function formatMessage(){
    let newAcctAccess = 'None'
    if (document.getElementById("accountAccessAddAll") && document.getElementById("accountAccessAddAll").checked) {
      newAcctAccess = 'All'
    }
    let message = {
      "firmInformation" : {
        "firmName": firmName,
        "firmIdentifier": identifier},
      "newFirmContact" : {
        "firstName": document.getElementById("firstNameADD").value,
        "lastName": document.getElementById("lastNameADD").value,
        "email": document.getElementById("emailADD").value,
        "phone": document.getElementById("phoneADD").value,
        "extension": document.getElementById("extensionADD").value,
        "addressLine1": document.getElementById("address1ADD").value,
        "addressLine2": document.getElementById("address2ADD").value,
        "city": document.getElementById("cityADD").value,
        "state": document.getElementById("stateADD").value,
        "zipCode": document.getElementById("zipADD").value},
      "accessNeeded" : {  
        "compensationStatement": convertBooleanToYesNo(document.getElementById("compensationAddYes").checked),
        "commissions": convertBooleanToYesNo(document.getElementById("commissionAddYes").checked),
        "managementComp": convertBooleanToYesNo(document.getElementById("managementCompensationAddYes").checked),
        "variableManagement": convertBooleanToYesNo(document.getElementById("variableManagementAddYes").checked),
        "accountAccess" : newAcctAccess},
      "otherData" : {  
        "replaceExisting" : document.getElementById("replaceADD").value,
        "requesterEmail" : props.requesterEmail}
    }
    return message;
  }

  async function resetList(validToken) {
    let resp = null

    if (isNumber(props.searchValue)) {
      resp = await retrieveFirmContactDataByTaxId(validToken, props.searchValue);
    } else {
      resp = await retrieveFirmContactData(validToken, props.searchValue);
    }
  
    props.setFcDisplayResponse(null);
    props.setfcResponse(resp.responseBody);
    props.setFcEditMode(false);
    props.setFcAddMode(false);
    return resp;
  }
  async function submitFCAdd() {
      if (props.CSR) {
        const isDemographicAdd = document.getElementById("demographicDataAdd").checked
        if (isDemographicAdd) {
          submitDemographicAdd("demographicAdd")
        } else {
          submitDemographicAdd("eidAdd")
        }
      } else {
        if (validEntry()) {
          let message = formatMessage();
          let validToken = props.user.access_token;
          try {
              if (props.user.expired) {
                validToken = await refreshAccessToken(props.user.refresh_token);
              }
              const data = await pushToSNS(validToken, message);
              if (data.MessageId) {
                props.setGlobalAlert(
                  {
                    id: "success-add",
                    type: "success",
                    message:
                      `Firm Contact request email was successfully sent. AWS MessageID : ${data.MessageId}`,
                    hidden: false,
                  }
                )
              } else {
                props.setGlobalAlert(
                  {
                  id: "error-add",
                  type: "error",
                  message:
                    "Firm Contact request email was not sent.",
                  hidden: false,
                })
              }
          } catch (err) {
            props.setGlobalAlert(
              {
                id: "error-add",
                type: "error",
                message:
                  "Error on email delivery " + err,
                hidden: false,
              }
            )
              console.log("Error", err.stack);
          }
          await resetList(validToken);
        }
      }
  }

  async function viewPerson() {

    document.getElementById("viewPersonSpinner").hidden = false

    props.setGlobalAlert(
      {
        id: "",
        type: "",
        message:
          "",
        hidden: true,
      }
    )
    
    let eid = document.getElementById("eidAddField").value.toUpperCase()

    document.getElementById("submitViewPersonButton").disabled = true

    let validToken = props.user.access_token;
      if (props.user.expired) {
        validToken = await refreshAccessToken(props.user.refresh_token);
      }

    let eidResponse = await retrieveByEid(validToken, eid)
    
    
    props.setViewPersonResponse(eidResponse)

    document.getElementById("submitViewPersonButton").disabled = false
    document.getElementById("viewPersonSpinner").hidden = true

  }

  async function submitDemographicAdd(addType) {

    if (addType === "eidAdd" || validEntry()) {
      let validToken = props.user.access_token;
      if (props.user.expired) {
        validToken = await refreshAccessToken(props.user.refresh_token);
      }

      props.setSpinnerActive(true)
      document.getElementById("submitAddFirmButton").disabled = true

      let newAcctAccess = 'N'
      if (document.getElementById("accountAccessAddAll") && document.getElementById("accountAccessAddAll").checked) {
        newAcctAccess = 'A'
      }

      let request = null

      if(addType === "eidAdd") {

        request = {
          "appIdentifier": "FirmContact",
          "csrEid": props.userEid,
          "requester": {
            "enterpriseID": props.userEid
          },
          "delegatingEntities": [
            {
              "dpEid": singleFirmEid,
              "roleCd": "20",
              "organization": true,
              "delegates": [
                {
                  "eid": document.getElementById("eidAddField").value,
                  "name": {},
                  "emailAddress": {},
                  "postalAddress": {},
                  "phoneNumber": {},
                  "appAccessList": [
                    {
                      "appTypeText": null,
                      "appTypeCode": "1",
                      "dlgtAccessCode": convertBooleanToAccessCode(true)
                    },
                    {
                      "appTypeText": null,
                      "appTypeCode": "2",
                      "dlgtAccessCode": convertBooleanToAccessCode(document.getElementById("compensationAddYes").checked)
                    },
                    {
                      "appTypeText": null,
                      "appTypeCode": "3",
                      "dlgtAccessCode": convertBooleanToAccessCode(document.getElementById("commissionAddYes").checked)
                    },
                    {
                      "appTypeText": null,
                      "appTypeCode": "4",
                      "dlgtAccessCode": convertBooleanToAccessCode(document.getElementById("managementCompensationAddYes").checked)
                    },
                    {
                      "appTypeText": null,
                      "appTypeCode": "5",
                      "dlgtAccessCode": convertBooleanToAccessCode(document.getElementById("variableManagementAddYes").checked)
                    }
                  ],
                  "accountAccess": {
                    "currentAccess": newAcctAccess,
                    "futureAccess": newAcctAccess
                  }
                }
              ]
            }
          ]
        }

      } else {

        let areaCode = document.getElementById("phoneADD").value.substring(1, 4);
        let phoneNumber = document.getElementById("phoneADD").value.substring(5,8) + document.getElementById("phoneADD").value.substring(9);

        request = {
          "appIdentifier": "FirmContact",
          "csrEid": props.userEid,
          "requester": {
            "enterpriseID": props.userEid
          },
          "delegatingEntities": [
            {
              "dpEid": singleFirmEid,
              "roleCd": "20",
              "organization": true,
              "delegates": [
                {
                  "eid": null,
                  "name": {
                    "firstName": document.getElementById("firstNameADD").value,
                    "middleName": null,
                    "lastName": document.getElementById("lastNameADD").value,
                    "suffix": null,
                    "fullName": null
                  },
                  "emailAddress": {
                    "email": document.getElementById("emailADD").value,
                    "emailType": "2"
                  },
                  "postalAddress": {
                    "addressLine1": document.getElementById("address1ADD").value,
                    "addressLine2": document.getElementById("address2ADD").value,
                    "city": document.getElementById("cityADD").value,
                    "state": document.getElementById("stateADD").value,
                    "zipCode": document.getElementById("zipADD").value
                  },
                  "phoneNumber": {
                    "areaCode": areaCode,
                    "number": phoneNumber,
                    "extension": document.getElementById("extensionADD").value,
                    "phoneType": "W"
                  },
                  "appAccessList": [
                    {
                      "appTypeText": null,
                      "appTypeCode": "1",
                      "dlgtAccessCode": convertBooleanToAccessCode(true)
                    },
                    {
                      "appTypeText": null,
                      "appTypeCode": "2",
                      "dlgtAccessCode": convertBooleanToAccessCode(document.getElementById("compensationAddYes").checked)
                    },
                    {
                      "appTypeText": null,
                      "appTypeCode": "3",
                      "dlgtAccessCode": convertBooleanToAccessCode(document.getElementById("commissionAddYes").checked)
                    },
                    {
                      "appTypeText": null,
                      "appTypeCode": "4",
                      "dlgtAccessCode": convertBooleanToAccessCode(document.getElementById("managementCompensationAddYes").checked)
                    },
                    {
                      "appTypeText": null,
                      "appTypeCode": "5",
                      "dlgtAccessCode": convertBooleanToAccessCode(document.getElementById("variableManagementAddYes").checked)
                    }
                  ],
                  "accountAccess": {
                    "currentAccess": newAcctAccess,
                    "futureAccess": newAcctAccess
                  }
                }
              ]
            }
          ]
        }

      }


      let resp = null
      resp = await addDelegates(validToken, request)
      document.getElementById("submitAddFirmButton").disabled = false;
      props.setSpinnerActive(false);
      props.setViewPersonResponse(null)
      document.getElementById("demographicDataAdd").checked = true
      props.setIsDemographicAdd(true)
      if (resp != null) {
        if (resp.status === 204) {
          await resetList(validToken);
          props.setGlobalAlert(
            {
              id: "success-add",
              type: "success",
              message:
                "Firm Contact was successfully built",
              hidden: false,
            }
          )
        } else if (resp.status === 400) {
          if (resp.statusText.toUpperCase().indexOf('EMAIL') > -1) {
            document.getElementById("emailADD").focus();
            props.setGlobalAlert(
              {
                id: "required-field-alert",
                type: "error",
                message:
                  "Invalid email was entered.",
                hidden: false,
              }
            )
          } else if (resp.statusText.toUpperCase().indexOf('PHONE') > -1){
            document.getElementById("phoneADD").focus();
            props.setGlobalAlert(
              {
                id: "required-field-alert",
                type: "error",
                message:
                  "Invalid phone number was entered.",
                hidden: false,
              }
            )
          } else {
            document.getElementById("demographicDataAdd").checked = false
            props.setIsDemographicAdd(false)
            props.setGlobalAlert(
              {
                id: "required-field-alert",
                type: "error",
                message:
                  "EID was not found in MDM.",
                hidden: false,
              }
            )
          }
          
        } else if (resp.status === 406) {
          props.setGlobalAlert(
            {
              id: "relationship-exists",
              type: "error",
              message:
                "Affiliate already related. ",
              hidden: false,
            }
          )
        } else {
          props.setGlobalAlert(
            {
              id: "internal-error",
              type: "error",
              message:
                "An error occured and the firm contact was not able to be built. ",
              hidden: false,
            }
          )

        }
      }
    }
  }

  return (
    <div>

      <h3>Firm Information</h3>
      <strong>Firm Name:</strong> {`${firmName}`} <br></br>
      <strong>Firm Identifier:</strong> {`${identifier}`} <br></br>

      <br></br>
      <div className="pds-divider">
        <span
          className="pds-divider-content pds-typography-bold"
          fontSize="14"
        >
          1 - Select Method to Build Firm Contact
        </span>
        <br></br> 
        {props.CSR ? 
        <>Select how to setup this firm contact:  Using Demographic Data, or an Existing EID :</>
        :
        <>Requesting a new FC requires dempgraphic data entry :</>
        }
      </div>
      <br></br>

      {props.CSR && <><div className="pds-segmentedControl" tabIndex="99" >
        <Slider name="typeOfAdd" id="demographicDataAdd" value="Demographics" selected={demographicData} onClick={switchAddMode}></Slider>
        <Slider name="typeOfAdd" id="eidAdd" value="EID" selected={!demographicData} onClick={switchAddMode}></Slider>
      </div>
      <br></br>
      </>}

      {props.isDemographicAdd
        ?
        <div>
          <div className="pds-divider">
            <span className="pds-divider-content pds-typography-bold">2 - Build Firm Contact using Demographic Data</span>
          </div>
          <br></br>
          <table
            className="pds-table pds-table-bordered"
            id='pds-datatable-demographicADD'
            aria-live="polite">
            <tbody>
              <tr>
                <td>
                  <div>
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="firstNameADD" className="pds-label">
                          First Name
                          <span className="pds-label-required" aria-hidden="true">*</span> </label></strong>
                        <input id="firstNameADD" aria-label="" tabIndex="1" autoFocus type="text" className="pds-validation col-6" required />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="address1ADD" className="pds-label">
                          Address 1
                          <span className="pds-label-required" aria-hidden="true">*</span> </label></strong>
                        <input id="address1ADD" aria-label="" tabIndex="6" type="text" className="pds-validation col-10" required defaultValue={add1}/>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="lastNameADD" className="pds-label">
                          Last Name
                          <span className="pds-label-required" aria-hidden="true">*</span> </label></strong>
                        <input id="lastNameADD" aria-label="" tabIndex="2" type="text" className="pds-validation col-6" required />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="address2ADD" className="pds-label">
                          Address 2
                        </label></strong>
                        <input id="address2ADD" aria-label="" tabIndex="7" type="text" className="pds-validation col-10" defaultValue={add2}/>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="emailADD" className="pds-label">
                          Email Address
                          <span className="pds-label-required" aria-hidden="true">*</span> </label></strong>
                        <input id="emailADD" aria-label="" tabIndex="3" type="text" className="pds-validation col-6" required />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="cityADD" className="pds-label">
                          City
                          <span className="pds-label-required" aria-hidden="true">*</span> </label></strong>
                        <input id="cityADD" aria-label="" tabIndex="8" type="text" className="pds-validation col-10" required defaultValue={city}/>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="phoneADD" className="pds-label">
                          Phone Number
                          <span className="pds-label-required" aria-hidden="true">*</span> </label></strong>
                        <input
                          id="phoneADD"
                          aria-label=""
                          tabIndex="4"
                          type="text"
                          placeholder="(999)999-9999"
                          className="pds-validation col-6"
                          required
                          maxLength="13"
                          minLength="13"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onKeyUp={() => {
                            addPhoneFormat()
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <StatePicker default={state}/>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="extensionADD" className="pds-label">
                          Extension
                        </label></strong>
                        <input
                          id="extensionADD"
                          aria-label=""
                          tabIndex="5"
                          type="text"
                          className="pds-validation col-3"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="zipADD" className="pds-label">
                          Zip
                          <span className="pds-label-required" aria-hidden="true">*</span> </label></strong>
                        <input
                          id="zipADD"
                          aria-label=""
                          tabIndex="10"
                          type="text"
                          placeholder="99999-9999"
                          className="pds-validation col-4"
                          required
                          maxLength="10"
                          defaultValue={zip}
                          minLength="5"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onKeyUp={() => {
                            addZipFormat()
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              {!props.CSR && <tr>
                <td>
                </td>
                <td>
                  <div>
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="replaceADD" className="pds-label">
                          If replacing an existing FC, enter the name here
                          </label></strong>
                        <input
                          id="replaceADD"
                          aria-label=""
                          tabIndex="12"
                          type="text"
                          className="pds-validation col-4"
                        />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>

      :
      <div>
        <div className="pds-divider">
            <span className="pds-divider-content pds-typography-bold">2 - Build Firm Contact using existing EID</span>
          </div>
        <br></br>
        <table
            className="pds-table"
            id='pds-datatable-eidADD'
            aria-live="polite">
              <tbody>
              <tr>
                <td className="col-1">
                    <div className="pds-erroredInput">
                      <div className="pds-labeledInput">
                        <strong><label htmlFor="eidAddField" className="pds-label">
                          Enterprise ID:
                          <span className="pds-label-required" aria-hidden="true">*</span> </label></strong>
                        <input id="eidAddField" aria-label="" tabIndex="1" autoFocus type="text" className="pds-validation force-caps" required />
                      </div>
                    </div>
                </td>
                <td className="col-1">
                  <button
                    className="pds-button pds-button-primary"
                    data-gtm="modal-cta"
                    id="submitViewPersonButton"
                    onClick={viewPerson}
                    tabIndex="16"
                    type="submit"
                  >
                    View Person
                  </button>
                </td>
                <td className="col-3">
                  <div id="viewPersonSpinner" hidden={true} className="col-1">
                    <div
                      className="pds-util-inline-flex pds-animatedIcon-rotate" aria-label="loading">
                      <i data-feather="loader" aria-hidden="true"></i>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
          </table>
          <br></br>
          {props.viewPersonResponse &&
            <table
              className="pds-table pds-table-bordered col-6"
              id='pds-datatable-eidADD'
              aria-live="polite">
                <thead>
                  <tr>
                    <th>First Name</th>
                  { props.viewPersonResponse.middleName !== null && props.viewPersonResponse.middleName !== " " && <th>Middle Name</th> }
                    <th>Last Name</th>
                  { props.viewPersonResponse.nameSuffixCode &&  <th>Suffix</th> }
                    <th>EID</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {props.viewPersonResponse.firstName}
                    </td>
                    { props.viewPersonResponse.middleName !== null && props.viewPersonResponse.middleName !== " " &&
                      <td>
                        {props.viewPersonResponse.middleName}
                      </td>
                    }
                    <td>
                      {props.viewPersonResponse.lastName}
                    </td>
                    { props.viewPersonResponse.nameSuffixCode &&
                      <td>
                        {props.viewPersonResponse.nameSuffixCode}
                      </td>
                    }
                    <td>
                      {props.viewPersonResponse.enterpriseId}
                    </td>
                  </tr>
              </tbody>
            </table>
          }
                

      </div>
      }

      <br></br>

      <div className="pds-divider">
        <span className="pds-divider-content pds-typography-bold">3 - Select Firm Contact Access</span>
      </div>
      <br></br>

      <table
        className="pds-table pds-table-bordered"
        id='pds-datatable-demographicADD'
        aria-live="polite">
        <tbody>
          <tr>
            <td>
              <strong>Compensation Statement: </strong> <br></br>
              <div className="pds-segmentedControl" tabIndex="20" >
                <Slider name="compensationOption" id="compensationAddYes" value="Yes" selected={compensationStatements}></Slider>
                <Slider name="compensationOption" id="compensationAddNo" value="No" selected={!compensationStatements}></Slider>
              </div>
            </td>
            <td>
              <strong>Account Access : </strong> <br></br>
              <div className="pds-segmentedControl" tabIndex="22" >
                <Slider name="accountAccessOption" id="accountAccessAddAll" value="All" selected={currentAccess}></Slider>
                <Slider name="accountAccessOption" id="accountAccessAddNone" value="None" selected={!currentAccess}></Slider>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Commissions: </strong> <br></br>
              <div className="pds-segmentedControl" tabIndex="23" >
                <Slider name="commissionAccessOption" id="commissionAddYes" value="Yes" selected={commissions}></Slider>
                <Slider name="commissionAccessOption" id="commissionAddNo" value="No" selected={!commissions}></Slider>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Management Compensation: </strong> <br></br>
              <div className="pds-segmentedControl" tabIndex="24" >
                <Slider name="managementCompensationAccessOption" id="managementCompensationAddYes" value="Yes" selected={managementCompensation}></Slider>
                <Slider name="managementCompensationAccessOption" id="managementCompensationAddNo" value="No" selected={!managementCompensation}></Slider>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Variable Management Comp: </strong> <br></br>
              <div className="pds-segmentedControl" tabIndex="25" >
                <Slider name="variableManagementAccessOption" id="variableManagementAddYes" value="Yes" selected={variableManagementComp}></Slider>
                <Slider name="variableManagementAccessOption" id="variableManagementAddNo" value="No" selected={!variableManagementComp}></Slider>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <br></br>
      <br></br>
      <button
        className="pds-button pds-button-primary"
        data-gtm="modal-cta"
        id="submitAddFirmButton"
        onClick={submitFCAdd}
        tabIndex="26"
        type="submit"
      >
        {buttonName}
      </button>
      &nbsp;
      <button
        className="pds-button pds-button-secondary"
        data-gtm="modal-cta"
        id="firmFcListButton"
        onClick={returnToFcList}
        tabIndex="27"
      >
        Cancel
      </button>
    </div>
  );
}


